<template lang="pug">
v-dialog(v-model="show", persistent, max-width="50%")
    v-card(v-if="indicadores")
        v-card-title.title Pedidos Cancelados
        v-card-text
          v-layout(column,wrap, style="background-color:#FAFAFA; border-radius:8px").pt-3.pb-3.mb-3.mt-3.pl-3.pr-3
            v-layout(row,wrap).pb-1
              v-flex.md12.xs12
                label(style="font-weight:400;font-size:18px; color:#111312CC") Total de pedidos cancelados por tempo
            v-layout(row,wrap)
              v-flex.md8.xs12
                small(style="font-size:16px; color:#1113128A") {{ indicadores.quantidade_cancelados_expirados | number }} pedidos
              v-flex.md4.xs12.text-md-right(style="font-size:16px; color:#0F7641")
                strong +{{ indicadores.total_bruto_cancelados_expirados_sem_taxa_servico | currency }}
            v-layout(row,wrap, v-if="indicadores.quantidade_taxa_servico_cancelados_expirados")
              v-flex.md8.xs12
                small(style="font-size:16px; color:#1113128A") {{ indicadores.quantidade_taxa_servico_cancelados_expirados | number }} taxas de serviço
              v-flex.md4.xs12.text-md-right(style="font-size:16px; color:#0F7641")
                strong +{{ indicadores.total_taxa_servico_cancelados_expirados | currency }}

          v-layout(column,wrap, style="background-color:#FAFAFA; border-radius:8px").pt-3.pb-3.mb-3.mt-3.pl-3.pr-3
            v-layout(row,wrap).pb-1
              v-flex.md12.xs12
                label(style="font-weight:400;font-size:18px; color:#111312CC") Total de pedidos cancelados por outros motivos
            v-layout(row,wrap)
              v-flex.md8.xs12
                small(style="font-size:16px; color:#1113128A") {{ indicadores.quantidade_cancelados_nao_expirados | number }} pedidos
              v-flex.md4.xs12.text-md-right(style="font-size:16px; color:#0F7641")
                strong +{{ indicadores.total_bruto_cancelados_nao_expirados_sem_taxa_servico | currency }}
            v-layout(row,wrap, v-if="indicadores.quantidade_taxa_servico_cancelados_nao_expirados")
              v-flex.md8.xs12
                small(style="font-size:16px; color:#1113128A") {{ indicadores.quantidade_taxa_servico_cancelados_nao_expirados | number }} taxas de serviço
              v-flex.md4.xs12.text-md-right(style="font-size:16px; color:#0F7641")
                strong +{{ indicadores.total_taxa_servico_cancelados_nao_expirados | currency }}

          div(style="border:1px solid; border-radius:8px; color:#0000000A").pt-3.pb-3.mb-3.mt-3.pl-3
            v-layout(row, wrap)
              v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                strong Total
              v-flex.md4.xs12.text-md-right.pr-3(style="font-size:18px; color:#000")
                strong {{ indicadores.total_cancelados | currency }}

        v-card-actions.mr-4.pb-3
            v-spacer
            v-btn(flat,@click="close()") Fechar

</template>

<script>

export default {
  props: {
  },
  data () {
    return {
        show : false,
        indicadores : null,
    }
  },
  created () {

  },
  watch: {
  },
  computed: {
  },
  methods: {
    open(indicadores){
      const vm = this;
      vm.indicadores = indicadores;
      vm.show = true;
    },
    close(){
        const vm = this;
        vm.indicadores = null;
        vm.show = false;
    }
  }
}
</script>
